const CategorySection = ({ categories, formulas, onCategoryClick, onFormulaClick }) => {
    return (
        <div className="grid grid-cols-3 gap-2 md:flex items-center justify-center px-2">
            <button
                onClick={onFormulaClick}
                className="bg-primary text-white px-4 py-2 rounded-[12px]"
            >
                Formules
            </button>
            {categories.map((category) => (
                <button
                    key={category.id}
                    onClick={() => onCategoryClick(category.id)}
                    className="bg-primary text-white px-4 py-2 rounded-[12px]"
                    style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                    {category.name}
                </button>
            ))}
        </div>
    );
};

export default CategorySection;
